module.exports = __webpack_public_path__ + "static/media/success-check-purple.76648f3c.png";